import { Dispatch, SetStateAction, useMemo } from "react";
import { Column, VisibilityState } from "@tanstack/table-core";
import { genericMemo } from "../../../../../../utils";
import { Checkbox } from "../../../../../inputs";
import { SortableItemContainerProps, SortableList } from "../../../../../SortableList";
import { renderColumnHeader } from "../../../../utils";

import styles from "./styles.module.scss";

export type ColumnsBlockProps<T extends Column<Object, any>> = {
  label: string;
  columns: T[];
  filterValues?: (v: T) => boolean,
  onChange?: (v: T[]) => void,
  dndDisabled?: boolean,
  columnVisibility: VisibilityState,
  setColumnVisibility: Dispatch<SetStateAction<VisibilityState>>,
}

export const ColumnsBlock = genericMemo(<T extends Column<Object, any>>(
  {
    label,
    onChange,
    filterValues,
    columns,
    dndDisabled,
    columnVisibility,
    setColumnVisibility,
  }: ColumnsBlockProps<T>) => {
  return (
    <div className={styles.block}>
      <label className={styles.blockLabel}>
        {label}
      </label>
      <SortableList
        className={styles.list}
        value={columns}
        disabled={dndDisabled}
        filterValues={filterValues}
        getItemId={item => item.id}
        containerProps={useMemo(() => ({
          className: styles.sortableContainer,
          dragButtonPosition: "end",
        } as SortableItemContainerProps), [])}
        onChange={onChange || (() => {})}
        renderItem={
          (column) => (
            <Checkbox
              className={styles.columnRow}
              key={column.id}
              value={columnVisibility[column.id] ?? true}
              disabled={!column.getCanHide()}
              onChange={(v) => setColumnVisibility(prevState => ({ ...prevState, [column.id]: v }))}
              text={renderColumnHeader(column)}
            />
          )
        }
      />
    </div>
  );
});
